import { render, staticRenderFns } from "./ScanTradeIns.vue?vue&type=template&id=d0a10fda&"
import script from "./ScanTradeIns.vue?vue&type=script&lang=js&"
export * from "./ScanTradeIns.vue?vue&type=script&lang=js&"
import style0 from "./ScanTradeIns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports